
import { LogoHp } from '@veneer/core';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export const WelcomeBanner = () => {
    var firstname: string = (window as any).username ? (window as any).username : "firstname";
    const {t} = useTranslation();
    return (
        <Col className='welcome-banner'>
            <h3  >{t("HPI.DefaultMaster.cs.Welcome",{ defaultValue: 'Welcome ,' })} <span dangerouslySetInnerHTML={{ __html: firstname }}></span></h3>
        </Col>
    )
}